import React, {useContext} from 'react';
import { TextInput, Button } from '../../components';
import * as PATHS from '../../settings/paths';
import AuthWrapper from './AuthWrapper/AuthWrapper';
import { Row, Col } from 'react-flexbox-grid';
import styles from './styles.module.css';
import { Link } from 'react-router-dom';
import { LanguageContext } from '../../context/Languages/LanguageProvider';

const ForgotPassword = () => {
  const { i18n } = useContext(LanguageContext);

  return (
    <AuthWrapper>
      <div className={styles.login}>
        <h3>{i18n.forgotPassword}</h3>
        <p>{i18n.enterYourEmailReset}</p>
        <TextInput type={"email"} placeholder={i18n.emailAddress} />
        <Row>
          <Col lg={5}>
            <Link to={PATHS.LOGIN} className={styles.forgot}>
              {i18n.rememberYourPassword}
            </Link>
          </Col>
          <Col lg={2}></Col>
          <Col lg={5}>
            <Button style={{ backgroundColor: "var(--text-red)" }}>{i18n.sendNewPassword}</Button>
          </Col>
        </Row>
      </div>
    </AuthWrapper>
  );
};

export default ForgotPassword;
